<template>
  <div class="c-designer">
    <designer-filter :month="month" :designerId="designerId" :designerName="designerName" />
    <div class="c-m-table">
      <designer-table ref="designerDetailTable" :loading="loading" :data="tableData" :columns="columns" :summary="summary" @on-del="del" />
      <Page
        show-total
        show-sizer
        show-elevator
        size="small"
        class="c-table-page"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import mixinTable from './mixin_table'
import DesignerFilter from './components/designer-detail-filter.vue'
import DesignerTable from './components/designer-detail-table.vue'
import columns from '../data/designer_detail_columns'
import { findDesignerDetailInfoByPage, deleteDesignerDetailInfo } from '@/api/manage.model'
import { isArray } from '@/common/js/utils'

export default {
  name: 'designerDetail',
  mixins: [mixinTable],
  components: { DesignerFilter, DesignerTable },
  data() {
    return {
      loading: false,
      tableData: [],
      sumData: [],
      columns: columns,
      month: this.$route.query.month,
      designerId: this.$route.query.designerId,
      designerName: this.$route.query.designerName
    }
  },
  methods: {
    getData() {
      const params = {
        month: this.month,
        designerId: this.designerId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      this.loading = true
      findDesignerDetailInfoByPage(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        if (isArray(list) && page_info && sum_data) {
          const { total_number } = page_info
          this.sumData = sum_data
          this.total = total_number || 0
          this.tableData = list
        } else this.tableData = []
        this.$nextTick(() => {
          this.$refs.designerDetailTable && this.$refs.designerDetailTable.doLayout()
        })
      })
    },
    summary(param) {
      const { columns } = param
      const data = this.sumData
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        sums[index] = data[`${prop}f`]
      })
      return sums
    },
    del(row) {
      const { month, programName, designerId } = row
      const params = {
        month,
        programName,
        designerId
      }
      this.loading = true
      deleteDesignerDetailInfo(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        this.$Message.success('操作成功')
        this.getData()
      })
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.c-designer {
  height: 100%;
}

.c-m-table {
  height: calc(100% - 48px);
  padding-top: 8px;
}

.c-table-page {
  padding: 0 8px;
  margin-top: 6px;
  text-align: right;
}
</style>
